import { render, staticRenderFns } from "./modalYouTube.vue?vue&type=template&id=0acb569d&scoped=true&"
import script from "./modalYouTube.vue?vue&type=script&lang=js&"
export * from "./modalYouTube.vue?vue&type=script&lang=js&"
import style0 from "./modalYouTube.vue?vue&type=style&index=0&id=0acb569d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb569d",
  null
  
)

export default component.exports